export default __webpack_public_path__ + "static/media/app.a228a7f1.webp";